export { InstructorDetailScreen } from "./InstructorDetailScreen";
